import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

interface CommunicationDemoState {
  isDemoDataReady: boolean;

  setIsDemoDataReady: (isDemoDataReady: boolean) => void;
}

const useCommunicationDemoStore = createStoreWithSubscribe<CommunicationDemoState>(
  (set) => ({
    isDemoDataReady: false,

    setIsDemoDataReady: (isDemoDataReady) => {
      set({ isDemoDataReady });
    },
  }),
  {
    name: 'CommunicationDemoStore',
    trace: true,
  }
);

export const useCommunicationDemoShallowStore = createShallowStore<CommunicationDemoState>(useCommunicationDemoStore);
